module.exports = __webpack_public_path__ + "img/15.eabd1a92.jpg";